export default [{
  name: 'autocred',
  namespaced: true,
  state: {
    model: {
      Pessoa: {
        PF: {},
        PJ: {},
        TipoPessoa: null,
        PessoaDadosContato: {
          Email: '',
        },
        PessoaEndereco: {},
        PessoaBanco: {},
      },
      Beneficiario: {
        Desembolso: 2,
        DocumentoFederal: '',
        RazaoSocial: '',
      },
      Produto: '',
      Parcela: {},
      Proposta: {},
      Avalista: {},
    },
  },
  mutations: {
    model (state, obj) {
      state.model = obj
    },
  },
  getters: {
    model (state) {
      return state.model
    },
  },
  actions: {
    clearModel ({ commit }) {
      const data = {
        Pessoa: {
          PF: {},
          PJ: {},
          TipoPessoa: null,
          PessoaDadosContato: {},
          PessoaEndereco: {},
          PessoaBanco: {},
        },
        Beneficiario: {},
        Produto: '',
        Parcela: {},
        DadosIniciais: {},
        Proposta: {}
      }
      commit('model', data)
    }
  },
}]
